module.exports = __webpack_public_path__ + "img/home-small.6e7bd884.png";